// ScreenShareView.jsx
import React, { useCallback, useRef } from "react";
import { Track } from "livekit-client";
import TrackTile from "./TrackTile";

export default function ScreenShareView({
  screenTrack,
  /** Remote cameras (including the screensharer) — stage shows only the shared screen. */
  participantsWithTracks,
  onTileClick,
  networkQuality,
  activeSpeakerSid,
  screenSharingSids,
}) {
  const stageWrapRef = useRef(null);
  const sharer = screenTrack?.participant;
  const sharerMic = sharer?.getTrack?.(Track.Source.Microphone);

  const toggleStageFullscreen = useCallback(() => {
    const el = stageWrapRef.current;
    if (!el) return;
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    } else {
      el.requestFullscreen?.().catch(() => {});
    }
  }, []);

  return (
    <div className="screen-layout">
      <div className="screen-stage-wrap" ref={stageWrapRef}>
        <button
          type="button"
          className="screen-fullscreen-btn"
          title="Fullscreen shared screen"
          aria-label="Fullscreen shared screen"
          onClick={(e) => {
            e.stopPropagation();
            toggleStageFullscreen();
          }}
        >
          ⛶
        </button>
        <div className="screen-stage">
          <TrackTile
            track={screenTrack}
            participant={sharer}
            variant="screen"
            showPinHint={false}
            isActive={false}
            networkLevel={sharer ? (networkQuality?.[sharer.sid] ?? 0) : 0}
            isAudioMuted={sharerMic ? sharerMic.isMuted : true}
            isVideoMuted={false}
            isScreenSharing={false}
            onClick={() => {}}
          />
        </div>
      </div>
      <div className="screen-sidebar">
        {(participantsWithTracks || []).map(({ participant, cameraTrack }) => {
          const micPub = participant?.getTrack?.(Track.Source.Microphone);
          const camPub = participant?.getTrack?.(Track.Source.Camera);
          const hasCameraPub = Boolean(camPub);
          const videoMuted = hasCameraPub
            ? (camPub.isMuted ?? !camPub.track)
            : true;
          return (
            <TrackTile
              key={participant.sid}
              participant={participant}
              track={cameraTrack || null}
              isActive={participant.sid === activeSpeakerSid}
              networkLevel={networkQuality?.[participant.sid] ?? 0}
              isAudioMuted={micPub ? micPub.isMuted : true}
              isVideoMuted={videoMuted}
              isScreenSharing={screenSharingSids?.has?.(participant.sid)}
              onClick={() => onTileClick(participant.sid)}
            />
          );
        })}
      </div>
    </div>
  );
}
